import { TPolygonFilter } from "./area-polygons-map.models";

export const POLYGON_FILTERS: { value: TPolygonFilter; labelKey: string }[] = [
  { value: "all", labelKey: "area.mapFilterAll" },
  { value: "with", labelKey: "area.mapFilterWith" },
  { value: "without", labelKey: "area.mapFilterWithout" },
];
